<template>
  <div></div>
</template>

<script>
import { LocalStorage } from "quasar";
import { mobileOrDesktop } from "../libs/device";
export default {
  name: "Index",
  async preFetch({ currentRoute, redirect }) {
    const sid = LocalStorage.getItem("sid");
    if (sid) {
      mobileOrDesktop("/meeting", currentRoute.query);
    }
    let route;
    if (currentRoute.query.d !== undefined && currentRoute.query.d.length > 0) {
      // link
      mobileOrDesktop(`/link`, currentRoute.query);
    } else {
      // widget
      mobileOrDesktop(`/widget`, currentRoute.query);
    }
    if (
      currentRoute.query.sequence !== undefined &&
      currentRoute.query.sequence.length > 0
    ) {
      // link
      mobileOrDesktop(`/sequence`, currentRoute.query);
    }
  }
};
</script>
